import { atom } from "recoil";
import { GoogleAutocompleteAddressProps } from "../../components/google-autocomplete/google-autocomplete-props";
export const businessGoogleAutocompleteState =
  atom<GoogleAutocompleteAddressProps | null>({
    key: "businessGoogleAutocompleteState",
    default: null,
  });
